<template>
  <a-modal :visible="visible" :title="title" @ok="submit" @cancel="close">
    <a-form :form="form">
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="教师姓名"
      >
        <a-input
          v-decorator="[
            'name',
            { rules: [{ required: true, message: '请填写教师姓名' }] }
          ]"
        ></a-input>
      </a-form-item>
      <a-form-item label="部门" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-tree-select
          v-decorator="[
            'deptId',
            { rules: [{ required: true, message: '请选择部门' }] }
          ]"
          :replaceFields="{
            title: 'title',
            key: 'key',
            value: 'key',
            children: 'children'
          }"
          style="width:100%"
          :treeData="depts"
        >
        </a-tree-select>
      </a-form-item>
      <a-form-item
        label="角色分配"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-select
          v-decorator="[
            'userRoleIdsList',
            { rules: [{ required: true, message: '请选择角色' }] }
          ]"
          mode="multiple"
          style="width:100%"
          placeholder="请选择角色"
          :options="roles"
        >
        </a-select>
      </a-form-item>
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="年级科目"
      >
        <a-tree-select
          multiple
          tree-checkable
          v-decorator="[
            'userSubject',
            { rules: [{ required: true, message: '请选择年级科目' }] }
          ]"
          :maxTagCount="11"
          :treeData="treeData"
          :replaceFields="replaceFields"
          :dropdown-style="{ maxHeight: '30vh', overflow: 'auto' }"
        >
        </a-tree-select>
      </a-form-item>
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="联系方式"
      >
        <a-input
          v-decorator="[
            'mobile',
            {
              rules: [
                { required: true, message: '请填写联系方式' },
                { pattern: '1[3589]\\d{9}', message: '请输入手机号码' }
              ]
            }
          ]"
        ></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { trees } from "@/api/base/tree/manager";
import { save } from "@/api/system/user";
import pick from "lodash/pick";
import { findAllDepts } from "@/api/system/dept";
import { upSort } from "@components/_util/util";
import { findByRoleCode } from "@/api/system/role";

export default {
  data() {
    return {
      //modal
      modal: {},
      visible: false,
      title: "新增",
      //form
      form: this.$form.createForm(this),
      labelCol: { span: 5 },
      wrapperCol: { span: 15 },
      treeData: [],
      replaceFields: {
        children: "jtypes",
        title: "name",
        key: "id",
        value: "id"
      },
      depts: [], //部门树
      roles: [] //角色列表
    };
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      // 角色
      findAllDepts().then(res => {
        this.depts = res.result;
      });

      // 部门
      findByRoleCode({ roleCodes: "ROLE_JS,ROLE_SP" }).then(res => {
        this.roles = res.map(item => {
          return { value: item.id, label: item.roleName };
        });
      });

      this.loadTrees();
    },

    // 加载资源目录树
    loadTrees() {
      trees().then(res => {
        this.treeData = res.result;

        // 过来获取三情分析
        // this.filterThree();

        // 过了获取年级
        this.filterGradeDisabledAttr(this.treeData);

        // 排序
        upSort(this.treeData);
      });
    },

    // 获取三情分析数据
    filterThree() {
      // 只需要三情分析中的数据
      let data = this.treeData.filter(item => {
        return "三情分析" == item.name;
      });
      if (data.length) {
        this.treeData = data[0].jtypes;
      }
    },

    // 过滤，只需要年级以上的数据
    filterGradeDisabledAttr(items) {
      // console.log(" === filtrGradeDisabledAttr === ");

      let _this = this;
      items.map(item => {
        // item.disabled = 0 == item.leveal ? true : false;

        // 只显示到科目
        if (3 == item.leveal) {
          item.jtypes = [];
        }
        if (item.jtypes) {
          _this.filterGradeDisabledAttr(item.jtypes);
        }
      });
    },

    show(record) {
      // console.log(" === show === ", record);

      this.visible = true;
      this.modal = {};

      if (record) {
        this.title = "修改";

        this.modal = record;

        this.modal.tel = record.mobile;
        if (
          record.userSubject &&
          "string" === typeof record.userSubject &&
          0 < record.userSubject.length
        ) {
          this.modal.userSubject = record.userSubject.split(",");
        }

        this.$nextTick(() => {
          this.treeData = record.treeData;
          let v = pick(
            this.modal,
            "name",
            "deptId",
            "userSubject",
            "mobile",
            "userRoleIdsList"
          );
          this.form.setFieldsValue(v);
        });
      }
    },
    close() {
      this.title = "新增";
      this.visible = false;
      this.form.resetFields();
    },
    submit() {
      // console.log(" === teacher manager submit === ", this.form.getFieldsValue());

      this.form.validateFields((err, values) => {
        this.loading = true;
        if (!err) {
          values.userSubject = values.userSubject.toString();
          let params = Object.assign(this.modal, values);
          params.loginName = params.name;
          params.treeData = [];
          if (params.userRoleIdsList) {
            params.userRoles = params.userRoleIdsList.toString();
          }
          // 默认状态为启用
          params.status = "A";
          save({ ...params }).then(res => {
            if (res.resultCode === 1) {
              this.$notification.success({ message: res.message });
              this.close();
              this.$emit("ok");
            } else {
              this.$notification.error({ message: res.message });
            }
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      });
    }
  }
};
</script>
<style></style>
